<user-detail-element [userConfig]="userConfig" (tokenToBeRenewed)="renewToken($event)"></user-detail-element>
